/**
 * 完整的菜单翻译映射表
 * 基于数据库中的实际菜单名称生成
 * 包含了所有菜单和操作按钮的翻译
 */

export default {
  // ==================== 系统管理 ====================
  '系统主页': {
    'en-US': 'Dashboard',
    'th-TH': 'หน้าหลัก',
    'vi-VN': 'Trang chủ',
    'ms-MY': 'Laman Utama',
    'id-ID': 'Beranda'
  },
  '系统管理': {
    'en-US': 'System',
    'th-TH': 'ระบบ',
    'vi-VN': 'Hệ thống',
    'ms-MY': 'Sistem',
    'id-ID': 'Sistem'
  },
  '系统监控': {
    'en-US': 'System Monitor',
    'th-TH': 'ตรวจสอบระบบ',
    'vi-VN': 'Giám sát hệ thống',
    'ms-MY': 'Pemantauan Sistem',
    'id-ID': 'Monitoring Sistem'
  },
  '用户管理': {
    'en-US': 'User',
    'th-TH': 'จัดการผู้ใช้',
    'vi-VN': 'Quản lý người dùng',
    'ms-MY': 'Pengurusan Pengguna',
    'id-ID': 'Manajemen Pengguna'
  },
  '角色管理': {
    'en-US': 'Role',
    'th-TH': 'จัดการบทบาท',
    'vi-VN': 'Quản lý vai trò',
    'ms-MY': 'Pengurusan Peranan',
    'id-ID': 'Manajemen Peran'
  },
  '菜单管理': {
    'en-US': 'Menu',
    'th-TH': 'จัดการเมนู',
    'vi-VN': 'Quản lý menu',
    'ms-MY': 'Pengurusan Menu',
    'id-ID': 'Manajemen Menu'
  },

  // ==================== 操作按钮 - 用户 ====================
  '新增用户': {
    'en-US': 'Add User',
    'th-TH': 'เพิ่มผู้ใช้',
    'vi-VN': 'Thêm người dùng',
    'ms-MY': 'Tambah Pengguna',
    'id-ID': 'Tambah Pengguna'
  },
  '修改用户': {
    'en-US': 'Edit User',
    'th-TH': 'แก้ไขผู้ใช้',
    'vi-VN': 'Sửa người dùng',
    'ms-MY': 'Edit Pengguna',
    'id-ID': 'Edit Pengguna'
  },
  '删除用户': {
    'en-US': 'Delete User',
    'th-TH': 'ลบผู้ใช้',
    'vi-VN': 'Xóa người dùng',
    'ms-MY': 'Padam Pengguna',
    'id-ID': 'Hapus Pengguna'
  },

  // ==================== 操作按钮 - 角色 ====================
  '新增角色': {
    'en-US': 'Add Role',
    'th-TH': 'เพิ่มบทบาท',
    'vi-VN': 'Thêm vai trò',
    'ms-MY': 'Tambah Peranan',
    'id-ID': 'Tambah Peran'
  },
  '修改角色': {
    'en-US': 'Edit Role',
    'th-TH': 'แก้ไขบทบาท',
    'vi-VN': 'Sửa vai trò',
    'ms-MY': 'Edit Peranan',
    'id-ID': 'Edit Peran'
  },
  '删除角色': {
    'en-US': 'Delete Role',
    'th-TH': 'ลบบทบาท',
    'vi-VN': 'Xóa vai trò',
    'ms-MY': 'Padam Peranan',
    'id-ID': 'Hapus Peran'
  },

  // ==================== 操作按钮 - 菜单 ====================
  '新增菜单': {
    'en-US': 'Add Menu',
    'th-TH': 'เพิ่มเมนู',
    'vi-VN': 'Thêm menu',
    'ms-MY': 'Tambah Menu',
    'id-ID': 'Tambah Menu'
  },
  '修改菜单': {
    'en-US': 'Edit Menu',
    'th-TH': 'แก้ไขเมนู',
    'vi-VN': 'Sửa menu',
    'ms-MY': 'Edit Menu',
    'id-ID': 'Edit Menu'
  },
  '删除菜单': {
    'en-US': 'Delete Menu',
    'th-TH': 'ลบเมนู',
    'vi-VN': 'Xóa menu',
    'ms-MY': 'Padam Menu',
    'id-ID': 'Hapus Menu'
  },

  // ==================== 商户管理 ====================
  '商户管理': {
    'en-US': 'Merchant',
    'th-TH': 'จัดการร้านค้า',
    'vi-VN': 'Quản lý cửa hàng',
    'ms-MY': 'Pengurusan Kedai',
    'id-ID': 'Manajemen Toko'
  },
  '商户列表': {
    'en-US': 'Merchant List',
    'th-TH': 'รายการร้านค้า',
    'vi-VN': 'Danh sách cửa hàng',
    'ms-MY': 'Senarai Kedai',
    'id-ID': 'Daftar Toko'
  },

  // ==================== 机器管理 ====================
  '机器管理': {
    'en-US': 'Machine',
    'th-TH': 'จัดการเครื่อง',
    'vi-VN': 'Quản lý máy',
    'ms-MY': 'Pengurusan Mesin',
    'id-ID': 'Manajemen Mesin'
  },

  // ==================== 模板管理 ====================
  '模板管理': {
    'en-US': 'Template',
    'th-TH': 'จัดการแม่แบบ',
    'vi-VN': 'Quản lý mẫu',
    'ms-MY': 'Pengurusan Templat',
    'id-ID': 'Manajemen Template'
  },
  'UI组管理': {
    'en-US': 'UI Group',
    'th-TH': 'จัดการกลุ่ม UI',
    'vi-VN': 'Quản lý nhóm UI',
    'ms-MY': 'Pengurusan Kumpulan UI',
    'id-ID': 'Manajemen Grup UI'
  },
  'UI管理': {
    'en-US': 'UI',
    'th-TH': 'จัดการ UI',
    'vi-VN': 'Quản lý UI',
    'ms-MY': 'Pengurusan UI',
    'id-ID': 'Manajemen UI'
  },
  '新增UI': {
    'en-US': 'Add UI',
    'th-TH': 'เพิ่ม UI',
    'vi-VN': 'Thêm UI',
    'ms-MY': 'Tambah UI',
    'id-ID': 'Tambah UI'
  },
  '查看UI': {
    'en-US': 'View UI',
    'th-TH': 'ดู UI',
    'vi-VN': 'Xem UI',
    'ms-MY': 'Lihat UI',
    'id-ID': 'Lihat UI'
  },
  '编辑UI': {
    'en-US': 'Edit UI',
    'th-TH': 'แก้ไข UI',
    'vi-VN': 'Sửa UI',
    'ms-MY': 'Edit UI',
    'id-ID': 'Edit UI'
  },
  '删除UI': {
    'en-US': 'Delete UI',
    'th-TH': 'ลบ UI',
    'vi-VN': 'Xóa UI',
    'ms-MY': 'Padam UI',
    'id-ID': 'Hapus UI'
  },
  '滤镜管理': {
    'en-US': 'Filter',
    'th-TH': 'จัดการฟิลเตอร์',
    'vi-VN': 'Quản lý bộ lọc',
    'ms-MY': 'Pengurusan Penapis',
    'id-ID': 'Manajemen Filter'
  },
  '新增滤镜': {
    'en-US': 'Add Filter',
    'th-TH': 'เพิ่มฟิลเตอร์',
    'vi-VN': 'Thêm bộ lọc',
    'ms-MY': 'Tambah Penapis',
    'id-ID': 'Tambah Filter'
  },
  '查看滤镜': {
    'en-US': 'View Filter',
    'th-TH': 'ดูฟิลเตอร์',
    'vi-VN': 'Xem bộ lọc',
    'ms-MY': 'Lihat Penapis',
    'id-ID': 'Lihat Filter'
  },
  '编辑滤镜': {
    'en-US': 'Edit Filter',
    'th-TH': 'แก้ไขฟิลเตอร์',
    'vi-VN': 'Sửa bộ lọc',
    'ms-MY': 'Edit Penapis',
    'id-ID': 'Edit Filter'
  },
  '删除滤镜': {
    'en-US': 'Delete Filter',
    'th-TH': 'ลบฟิลเตอร์',
    'vi-VN': 'Xóa bộ lọc',
    'ms-MY': 'Padam Penapis',
    'id-ID': 'Hapus Filter'
  },
  '边框背景管理': {
    'en-US': 'Frame Background',
    'th-TH': 'จัดการพื้นหลังกรอบ',
    'vi-VN': 'Quản lý nền khung',
    'ms-MY': 'Pengurusan Latar Bingkai',
    'id-ID': 'Manajemen Latar Bingkai'
  },
  '新增边框背景': {
    'en-US': 'Add Frame Background',
    'th-TH': 'เพิ่มพื้นหลังกรอบ',
    'vi-VN': 'Thêm nền khung',
    'ms-MY': 'Tambah Latar Bingkai',
    'id-ID': 'Tambah Latar Bingkai'
  },
  '查看边框背景': {
    'en-US': 'View Frame Background',
    'th-TH': 'ดูพื้นหลังกรอบ',
    'vi-VN': 'Xem nền khung',
    'ms-MY': 'Lihat Latar Bingkai',
    'id-ID': 'Lihat Latar Bingkai'
  },
  '编辑边框背景': {
    'en-US': 'Edit Frame Background',
    'th-TH': 'แก้ไขพื้นหลังกรอบ',
    'vi-VN': 'Sửa nền khung',
    'ms-MY': 'Edit Latar Bingkai',
    'id-ID': 'Edit Latar Bingkai'
  },
  '删除边框背景': {
    'en-US': 'Delete Frame Background',
    'th-TH': 'ลบพื้นหลังกรอบ',
    'vi-VN': 'Xóa nền khung',
    'ms-MY': 'Padam Latar Bingkai',
    'id-ID': 'Hapus Latar Bingkai'
  },

  // ==================== 产品管理 ====================
  '产品管理': {
    'en-US': 'Product',
    'th-TH': 'จัดการผลิตภัณฑ์',
    'vi-VN': 'Quản lý sản phẩm',
    'ms-MY': 'Pengurusan Produk',
    'id-ID': 'Manajemen Produk'
  },
  '新增产品': {
    'en-US': 'Add Product',
    'th-TH': 'เพิ่มผลิตภัณฑ์',
    'vi-VN': 'Thêm sản phẩm',
    'ms-MY': 'Tambah Produk',
    'id-ID': 'Tambah Produk'
  },
  '查看产品': {
    'en-US': 'View Product',
    'th-TH': 'ดูผลิตภัณฑ์',
    'vi-VN': 'Xem sản phẩm',
    'ms-MY': 'Lihat Produk',
    'id-ID': 'Lihat Produk'
  },
  '编辑产品': {
    'en-US': 'Edit Product',
    'th-TH': 'แก้ไขผลิตภัณฑ์',
    'vi-VN': 'Sửa sản phẩm',
    'ms-MY': 'Edit Produk',
    'id-ID': 'Edit Produk'
  },
  '删除产品': {
    'en-US': 'Delete Product',
    'th-TH': 'ลบผลิตภัณฑ์',
    'vi-VN': 'Xóa sản phẩm',
    'ms-MY': 'Padam Produk',
    'id-ID': 'Hapus Produk'
  },
  '价格设置': {
    'en-US': 'Price Settings',
    'th-TH': 'ตั้งค่าราคา',
    'vi-VN': 'Cài đặt giá',
    'ms-MY': 'Tetapan Harga',
    'id-ID': 'Pengaturan Harga'
  },

  // ==================== 订单管理 ====================
  '订单打印任务': {
    'en-US': 'Order Print Tasks',
    'th-TH': 'งานพิมพ์คำสั่งซื้อ',
    'vi-VN': 'Tác vụ in đơn hàng',
    'ms-MY': 'Tugas Cetakan Pesanan',
    'id-ID': 'Tugas Cetak Pesanan'
  },
  '订单管理': {
    'en-US': 'Order',
    'th-TH': 'จัดการคำสั่งซื้อ',
    'vi-VN': 'Quản lý đơn hàng',
    'ms-MY': 'Pengurusan Pesanan',
    'id-ID': 'Manajemen Pesanan'
  },
  '订单收入': {
    'en-US': 'Order Income',
    'th-TH': 'รายได้จากคำสั่งซื้อ',
    'vi-VN': 'Thu nhập đơn hàng',
    'ms-MY': 'Pendapatan Pesanan',
    'id-ID': 'Pendapatan Pesanan'
  },

  // ==================== 资金管理 ====================
  '资金管理': {
    'en-US': 'Fund',
    'th-TH': 'จัดการกองทุน',
    'vi-VN': 'Quản lý vốn',
    'ms-MY': 'Pengurusan Dana',
    'id-ID': 'Manajemen Dana'
  },
  '分成管理': {
    'en-US': 'Revenue Sharing',
    'th-TH': 'จัดการรายได้',
    'vi-VN': 'Quản lý chia sẻ',
    'ms-MY': 'Pengurusan Perkongsian',
    'id-ID': 'Manajemen Pembagian'
  },
  '添加银行卡': {
    'en-US': 'Add Bank Card',
    'th-TH': 'เพิ่มบัตรธนาคาร',
    'vi-VN': 'Thêm thẻ ngân hàng',
    'ms-MY': 'Tambah Kad Bank',
    'id-ID': 'Tambah Kartu Bank'
  },
  '编辑银行卡': {
    'en-US': 'Edit Bank Card',
    'th-TH': 'แก้ไขบัตรธนาคาร',
    'vi-VN': 'Sửa thẻ ngân hàng',
    'ms-MY': 'Edit Kad Bank',
    'id-ID': 'Edit Kartu Bank'
  },
  '查看银行卡': {
    'en-US': 'View Bank Card',
    'th-TH': 'ดูบัตรธนาคาร',
    'vi-VN': 'Xem thẻ ngân hàng',
    'ms-MY': 'Lihat Kad Bank',
    'id-ID': 'Lihat Kartu Bank'
  },
  '删除银行卡': {
    'en-US': 'Delete Bank Card',
    'th-TH': 'ลบบัตรธนาคาร',
    'vi-VN': 'Xóa thẻ ngân hàng',
    'ms-MY': 'Padam Kad Bank',
    'id-ID': 'Hapus Kartu Bank'
  },
  '商户提现管理': {
    'en-US': 'Merchant Withdrawal',
    'th-TH': 'จัดการการถอนเงินร้านค้า',
    'vi-VN': 'Quản lý rút tiền cửa hàng',
    'ms-MY': 'Pengurusan Pengeluaran Kedai',
    'id-ID': 'Manajemen Penarikan Toko'
  },
  '提现记录': {
    'en-US': 'Withdrawal Records',
    'th-TH': 'บันทึกการถอนเงิน',
    'vi-VN': 'Bản ghi rút tiền',
    'ms-MY': 'Rekod Pengeluaran',
    'id-ID': 'Rekaman Penarikan'
  },
  '审批': {
    'en-US': 'Approval',
    'th-TH': 'อนุมัติ',
    'vi-VN': 'Phê duyệt',
    'ms-MY': 'Kelulusan',
    'id-ID': 'Persetujuan'
  },
  '上传凭证': {
    'en-US': 'Upload Voucher',
    'th-TH': 'อัปโหลดหลักฐาน',
    'vi-VN': 'Tải lên chứng từ',
    'ms-MY': 'Muat Naik Bukti',
    'id-ID': 'Unggah Bukti'
  },

  // ==================== 会员管理 ====================
  '会员管理': {
    'en-US': 'Member',
    'th-TH': 'จัดการสมาชิก',
    'vi-VN': 'Quản lý thành viên',
    'ms-MY': 'Pengurusan Ahli',
    'id-ID': 'Manajemen Anggota'
  },
  '查看相片': {
    'en-US': 'View Photos',
    'th-TH': 'ดูรูปภาพ',
    'vi-VN': 'Xem ảnh',
    'ms-MY': 'Lihat Foto',
    'id-ID': 'Lihat Foto'
  },

  // ==================== 数据管理 ====================
  '数据管理': {
    'en-US': 'Data',
    'th-TH': 'จัดการข้อมูล',
    'vi-VN': 'Quản lý dữ liệu',
    'ms-MY': 'Pengurusan Data',
    'id-ID': 'Manajemen Data'
  },
  '基础数据': {
    'en-US': 'Basic Data',
    'th-TH': 'ข้อมูลพื้นฐาน',
    'vi-VN': 'Dữ liệu cơ bản',
    'ms-MY': 'Data Asas',
    'id-ID': 'Data Dasar'
  },
  '导出基础数据': {
    'en-US': 'Export Basic Data',
    'th-TH': 'ส่งออกข้อมูลพื้นฐาน',
    'vi-VN': 'Xuất dữ liệu cơ bản',
    'ms-MY': 'Eksport Data Asas',
    'id-ID': 'Ekspor Data Dasar'
  },
  '机器数据': {
    'en-US': 'Machine Data',
    'th-TH': 'ข้อมูลเครื่อง',
    'vi-VN': 'Dữ liệu máy',
    'ms-MY': 'Data Mesin',
    'id-ID': 'Data Mesin'
  },
  '导出设备数据': {
    'en-US': 'Export Device Data',
    'th-TH': 'ส่งออกข้อมูลอุปกรณ์',
    'vi-VN': 'Xuất dữ liệu thiết bị',
    'ms-MY': 'Eksport Data Peranti',
    'id-ID': 'Ekspor Data Perangkat'
  },
  '提现申请': {
    'en-US': 'Withdrawal Application',
    'th-TH': 'คำขอถอนเงิน',
    'vi-VN': 'Đơn rút tiền',
    'ms-MY': 'Permohonan Pengeluaran',
    'id-ID': 'Pengajuan Penarikan'
  },
  '主页数据': {
    'en-US': 'Homepage Data',
    'th-TH': 'ข้อมูลหน้าหลัก',
    'vi-VN': 'Dữ liệu trang chủ',
    'ms-MY': 'Data Laman Utama',
    'id-ID': 'Data Beranda'
  },

  // ==================== 在线用户 ====================
  '在线用户': {
    'en-US': 'Online Users',
    'th-TH': 'ผู้ใช้ ออนไลน์',
    'vi-VN': 'Người dùng trực tuyến',
    'ms-MY': 'Pengguna Dalam Talian',
    'id-ID': 'Pengguna Online'
  },
  '踢出用户': {
    'en-US': 'Kick Out User',
    'th-TH': 'เตะผู้ใช้',
    'vi-VN': 'Đuổi người dùng',
    'ms-MY': 'Tendang Pengguna',
    'id-ID': 'Keluarkan Pengguna'
  },

  // ==================== 系统日志 ====================
  '系统日志': {
    'en-US': 'System Logs',
    'th-TH': 'บันทึกระบบ',
    'vi-VN': 'Nhật ký hệ thống',
    'ms-MY': 'Log Sistem',
    'id-ID': 'Log Sistem'
  },
  '删除日志': {
    'en-US': 'Delete Logs',
    'th-TH': 'ลบบันทึก',
    'vi-VN': 'Xóa nhật ký',
    'ms-MY': 'Padam Log',
    'id-ID': 'Hapus Log'
  },
  '导出日志': {
    'en-US': 'Export Logs',
    'th-TH': 'ส่งออกบันทึก',
    'vi-VN': 'Xuất nhật ký',
    'ms-MY': 'Eksport Log',
    'id-ID': 'Ekspor Log'
  },

  // ==================== 监控相关 ====================
  'Redis监控': {
    'en-US': 'Redis Monitor',
    'th-TH': 'ตรวจสอบ Redis',
    'vi-VN': 'Giám sát Redis',
    'ms-MY': 'Pemantauan Redis',
    'id-ID': 'Monitoring Redis'
  },
  '请求追踪': {
    'en-US': 'Request Tracking',
    'th-TH': 'ติดตามคำขอ',
    'vi-VN': 'Theo dõi yêu cầu',
    'ms-MY': 'Penjejak Permintaan',
    'id-ID': 'Pelacakan Permintaan'
  },
  '系统信息': {
    'en-US': 'System Info',
    'th-TH': 'ข้อมูลระบบ',
    'vi-VN': 'Thông tin hệ thống',
    'ms-MY': 'Maklumat Sistem',
    'id-ID': 'Info Sistem'
  },
  'Tomcat信息': {
    'en-US': 'Tomcat Info',
    'th-TH': 'ข้อมูล Tomcat',
    'vi-VN': 'Thông tin Tomcat',
    'ms-MY': 'Maklumat Tomcat',
    'id-ID': 'Info Tomcat'
  },
  'JVM信息': {
    'en-US': 'JVM Info',
    'th-TH': 'ข้อมูล JVM',
    'vi-VN': 'Thông tin JVM',
    'ms-MY': 'Maklumat JVM',
    'id-ID': 'Info JVM'
  },
  '服务器信息': {
    'en-US': 'Server Info',
    'th-TH': 'ข้อมูลเซิร์ฟเวอร์',
    'vi-VN': 'Thông tin máy chủ',
    'ms-MY': 'Maklumat Pelayan',
    'id-ID': 'Info Server'
  },

  // ==================== 任务调度 ====================
  '任务调度': {
    'en-US': 'Task Scheduling',
    'th-TH': 'จัดกำหนดการงาน',
    'vi-VN': 'Lập lịch tác vụ',
    'ms-MY': 'Penjadualan Tugas',
    'id-ID': 'Penjadwalan Tugas'
  },
  '定时任务': {
    'en-US': 'Scheduled Tasks',
    'th-TH': 'งานที่กำหนดเวลา',
    'vi-VN': 'Tác vụ đã lên lịch',
    'ms-MY': 'Tugas Terjadual',
    'id-ID': 'Tugas Terjadwal'
  },
  '新增任务': {
    'en-US': 'Add Task',
    'th-TH': 'เพิ่มงาน',
    'vi-VN': 'Thêm tác vụ',
    'ms-MY': 'Tambah Tugas',
    'id-ID': 'Tambah Tugas'
  },
  '修改任务': {
    'en-US': 'Edit Task',
    'th-TH': 'แก้ไขงาน',
    'vi-VN': 'Sửa tác vụ',
    'ms-MY': 'Edit Tugas',
    'id-ID': 'Edit Tugas'
  },
  '删除任务': {
    'en-US': 'Delete Task',
    'th-TH': 'ลบงาน',
    'vi-VN': 'Xóa tác vụ',
    'ms-MY': 'Padam Tugas',
    'id-ID': 'Hapus Tugas'
  },
  '暂停任务': {
    'en-US': 'Pause Task',
    'th-TH': 'หยุดงานชั่วคราว',
    'vi-VN': 'Tạm dừng tác vụ',
    'ms-MY': 'Jeda Tugas',
    'id-ID': 'Tunda Tugas'
  },
  '恢复任务': {
    'en-US': 'Resume Task',
    'th-TH': 'ทำงานต่อ',
    'vi-VN': 'Tiếp tục tác vụ',
    'ms-MY': 'Sambung Tugas',
    'id-ID': 'Lanjutkan Tugas'
  },
  '立即执行任务': {
    'en-US': 'Execute Now',
    'th-TH': 'ดำเนินการทันที',
    'vi-VN': 'Thực hiện ngay',
    'ms-MY': 'Laksanakan Sekarang',
    'id-ID': 'Jalankan Sekarang'
  },
  '导出任务': {
    'en-US': 'Export Task',
    'th-TH': 'ส่งออกงาน',
    'vi-VN': 'Xuất tác vụ',
    'ms-MY': 'Eksport Tugas',
    'id-ID': 'Ekspor Tugas'
  },
  '调度日志': {
    'en-US': 'Schedule Logs',
    'th-TH': 'บันทึกการจัดกำหนดการ',
    'vi-VN': 'Nhật ký lịch trình',
    'ms-MY': 'Log Jadual',
    'id-ID': 'Log Penjadwalan'
  },
  '删除任务日志': {
    'en-US': 'Delete Task Logs',
    'th-TH': 'ลบบันทึกงาน',
    'vi-VN': 'Xóa nhật ký tác vụ',
    'ms-MY': 'Padam Log Tugas',
    'id-ID': 'Hapus Log Tugas'
  },
  '导出任务日志': {
    'en-US': 'Export Task Logs',
    'th-TH': 'ส่งออกบันทึกงาน',
    'vi-VN': 'Xuất nhật ký tác vụ',
    'ms-MY': 'Eksport Log Tugas',
    'id-ID': 'Ekspor Log Tugas'
  },

  // ==================== 字典管理 ====================
  '字典管理': {
    'en-US': 'Dictionary',
    'th-TH': 'จัดการพจนานุกรม',
    'vi-VN': 'Quản lý từ điển',
    'ms-MY': 'Pengurusan Kamus',
    'id-ID': 'Manajemen Kamus'
  },
  '新增字典': {
    'en-US': 'Add Dictionary',
    'th-TH': 'เพิ่มพจนานุกรม',
    'vi-VN': 'Thêm từ điển',
    'ms-MY': 'Tambah Kamus',
    'id-ID': 'Tambah Kamus'
  },
  '修改字典': {
    'en-US': 'Edit Dictionary',
    'th-TH': 'แก้ไขพจนานุกรม',
    'vi-VN': 'Sửa từ điển',
    'ms-MY': 'Edit Kamus',
    'id-ID': 'Edit Kamus'
  },
  '删除字典': {
    'en-US': 'Delete Dictionary',
    'th-TH': 'ลบพจนานุกรม',
    'vi-VN': 'Xóa từ điển',
    'ms-MY': 'Padam Kamus',
    'id-ID': 'Hapus Kamus'
  },
  '导出字典数据': {
    'en-US': 'Export Dictionary Data',
    'th-TH': 'ส่งออกข้อมูลพจนานุกรม',
    'vi-VN': 'Xuất dữ liệu từ điển',
    'ms-MY': 'Eksport Data Kamus',
    'id-ID': 'Ekspor Data Kamus'
  },

  // ==================== 版本管理 ====================
  '版本管理': {
    'en-US': 'Version',
    'th-TH': 'จัดการเวอร์ชัน',
    'vi-VN': 'Quản lý phiên bản',
    'ms-MY': 'Pengurusan Versi',
    'id-ID': 'Manajemen Versi'
  },
  '版本上传': {
    'en-US': 'Version Upload',
    'th-TH': 'อัปโหลดเวอร์ชัน',
    'vi-VN': 'Tải lên phiên bản',
    'ms-MY': 'Muat Naik Versi',
    'id-ID': 'Unggah Versi'
  },
  '版本删除': {
    'en-US': 'Version Delete',
    'th-TH': 'ลบเวอร์ชัน',
    'vi-VN': 'Xóa phiên bản',
    'ms-MY': 'Padam Versi',
    'id-ID': 'Hapus Versi'
  },
  '添加版本': {
    'en-US': 'Add Version',
    'th-TH': 'เพิ่มเวอร์ชัน',
    'vi-VN': 'Thêm phiên bản',
    'ms-MY': 'Tambah Versi',
    'id-ID': 'Tambah Versi'
  },

  // ==================== 通用操作按钮 ====================
  '设置': {
    'en-US': 'Settings',
    'th-TH': 'ตั้งค่า',
    'vi-VN': 'Cài đặt',
    'ms-MY': 'Tetapan',
    'id-ID': 'Pengaturan'
  },
  '绑定': {
    'en-US': 'Bind',
    'th-TH': 'ผูก',
    'vi-VN': 'Liên kết',
    'ms-MY': 'Ikat',
    'id-ID': 'Ikatan'
  },
  '解绑': {
    'en-US': 'Unbind',
    'th-TH': 'ยกเลิกการผูก',
    'vi-VN': 'Hủy liên kết',
    'ms-MY': 'Nyahikat',
    'id-ID': 'Lepas Ikatan'
  },
  '添加': {
    'en-US': 'Add',
    'th-TH': 'เพิ่ม',
    'vi-VN': 'Thêm',
    'ms-MY': 'Tambah',
    'id-ID': 'Tambah'
  },
  '查看': {
    'en-US': 'View',
    'th-TH': 'ดู',
    'vi-VN': 'Xem',
    'ms-MY': 'Lihat',
    'id-ID': 'Lihat'
  },
  '编辑': {
    'en-US': 'Edit',
    'th-TH': 'แก้ไข',
    'vi-VN': 'Sửa',
    'ms-MY': 'Edit',
    'id-ID': 'Edit'
  },
  '删除': {
    'en-US': 'Delete',
    'th-TH': 'ลบ',
    'vi-VN': 'Xóa',
    'ms-MY': 'Padam',
    'id-ID': 'Hapus'
  },
  '导出': {
    'en-US': 'Export',
    'th-TH': 'ส่งออก',
    'vi-VN': 'Xuất',
    'ms-MY': 'Eksport',
    'id-ID': 'Ekspor'
  },
  '新增': {
    'en-US': 'Add',
    'th-TH': 'เพิ่ม',
    'vi-VN': 'Thêm',
    'ms-MY': 'Tambah',
    'id-ID': 'Tambah'
  },
  '修改': {
    'en-US': 'Edit',
    'th-TH': 'แก้ไข',
    'vi-VN': 'Sửa',
    'ms-MY': 'Edit',
    'id-ID': 'Edit'
  },

  // ==================== 设备管理 ====================
  '设备导出': {
    'en-US': 'Device Export',
    'th-TH': 'ส่งออกอุปกรณ์',
    'vi-VN': 'Xuất thiết bị',
    'ms-MY': 'Eksport Peranti',
    'id-ID': 'Ekspor Perangkat'
  },
  '版本更新权限': {
    'en-US': 'Version Update Permission',
    'th-TH': 'สิทธิ์อัปเดตเวอร์ชัน',
    'vi-VN': 'Quyền cập nhật phiên bản',
    'ms-MY': 'Kebenaran Kemas Kini Versi',
    'id-ID': 'Izin Update Versi'
  },
  '查看照片': {
    'en-US': 'View Photos',
    'th-TH': 'ดูรูปภาพ',
    'vi-VN': 'Xem ảnh',
    'ms-MY': 'Lihat Foto',
    'id-ID': 'Lihat Foto'
  },
  '进件': {
    'en-US': 'Onboarding',
    'th-TH': 'ลงทะเบียน',
    'vi-VN': 'Đăng ký',
    'ms-MY': 'Pendaftaran',
    'id-ID': 'Pendaftaran'
  },
  '激活收钱吧': {
    'en-US': 'Activate Payment',
    'th-TH': 'เปิดใช้งานการชำระเงิน',
    'vi-VN': 'Kích hoạt thanh toán',
    'ms-MY': 'Aktifkan Pembayaran',
    'id-ID': 'Aktivasi Pembayaran'
  },
  '设备日志': {
    'en-US': 'Device Logs',
    'th-TH': 'บันทึกอุปกรณ์',
    'vi-VN': 'Nhật ký thiết bị',
    'ms-MY': 'Log Peranti',
    'id-ID': 'Log Perangkat'
  },
  '下载日志': {
    'en-US': 'Download Logs',
    'th-TH': 'ดาวน์โหลดบันทึก',
    'vi-VN': 'Tải nhật ký',
    'ms-MY': 'Muat Turun Log',
    'id-ID': 'Unduh Log'
  },
  '设备入库管理': {
    'en-US': 'Device Storage',
    'th-TH': 'จัดการคลังอุปกรณ์',
    'vi-VN': 'Quản lý kho thiết bị',
    'ms-MY': 'Pengurusan Stok Peranti',
    'id-ID': 'Manajemen Stok Perangkat'
  },
  '新增设备': {
    'en-US': 'Add Device',
    'th-TH': 'เพิ่มอุปกรณ์',
    'vi-VN': 'Thêm thiết bị',
    'ms-MY': 'Tambah Peranti',
    'id-ID': 'Tambah Perangkat'
  },
  '详情': {
    'en-US': 'Details',
    'th-TH': 'รายละเอียด',
    'vi-VN': 'Chi tiết',
    'ms-MY': 'Butiran',
    'id-ID': 'Detail'
  },

  // ==================== 优惠券管理 ====================
  '优惠券管理': {
    'en-US': 'Coupon',
    'th-TH': 'จัดการคูปอง',
    'vi-VN': 'Quản lý coupon',
    'ms-MY': 'Pengurusan Kupon',
    'id-ID': 'Manajemen Kupon'
  },

  // ==================== 退款管理 ====================
  '退款': {
    'en-US': 'Refund',
    'th-TH': 'คืนเงิน',
    'vi-VN': 'Hoàn tiền',
    'ms-MY': 'Bayaran Balik',
    'id-ID': 'Pengembalian Dana'
  },
  '退款审核': {
    'en-US': 'Refund Review',
    'th-TH': 'ตรวจสอบการคืนเงิน',
    'vi-VN': 'Kiểm tra hoàn tiền',
    'ms-MY': 'Semakan Bayaran Balik',
    'id-ID': 'Review Pengembalian'
  },

  // ==================== 贴纸管理 ====================
  '贴纸管理': {
    'en-US': 'Sticker',
    'th-TH': 'จัดการสติ๊กเกอร์',
    'vi-VN': 'Quản lý sticker',
    'ms-MY': 'Pengurusan Pelekat',
    'id-ID': 'Manajemen Stiker'
  },
  '贴纸分类': {
    'en-US': 'Sticker Category',
    'th-TH': 'หมวดหมู่สติ๊กเกอร์',
    'vi-VN': 'Danh mục sticker',
    'ms-MY': 'Kategori Pelekat',
    'id-ID': 'Kategori Stiker'
  },
  '添加分类': {
    'en-US': 'Add Category',
    'th-TH': 'เพิ่มหมวดหมู่',
    'vi-VN': 'Thêm danh mục',
    'ms-MY': 'Tambah Kategori',
    'id-ID': 'Tambah Kategori'
  },
  '修改分类': {
    'en-US': 'Edit Category',
    'th-TH': 'แก้ไขหมวดหมู่',
    'vi-VN': 'Sửa danh mục',
    'ms-MY': 'Edit Kategori',
    'id-ID': 'Edit Kategori'
  },
  '删除分类': {
    'en-US': 'Delete Category',
    'th-TH': 'ลบหมวดหมู่',
    'vi-VN': 'Xóa danh mục',
    'ms-MY': 'Padam Kategori',
    'id-ID': 'Hapus Kategori'
  },
  '导出分类': {
    'en-US': 'Export Category',
    'th-TH': 'ส่งออกหมวดหมู่',
    'vi-VN': 'Xuất danh mục',
    'ms-MY': 'Eksport Kategori',
    'id-ID': 'Ekspor Kategori'
  },
  '贴纸分组': {
    'en-US': 'Sticker Group',
    'th-TH': 'กลุ่มสติ๊กเกอร์',
    'vi-VN': 'Nhóm sticker',
    'ms-MY': 'Kumpulan Pelekat',
    'id-ID': 'Grup Stiker'
  },
  '添加分组': {
    'en-US': 'Add Group',
    'th-TH': 'เพิ่มกลุ่ม',
    'vi-VN': 'Thêm nhóm',
    'ms-MY': 'Tambah Kumpulan',
    'id-ID': 'Tambah Grup'
  },
  '修改分组': {
    'en-US': 'Edit Group',
    'th-TH': 'แก้ไขกลุ่ม',
    'vi-VN': 'Sửa nhóm',
    'ms-MY': 'Edit Kumpulan',
    'id-ID': 'Edit Grup'
  },
  '删除分组': {
    'en-US': 'Delete Group',
    'th-TH': 'ลบกลุ่ม',
    'vi-VN': 'Xóa nhóm',
    'ms-MY': 'Padam Kumpulan',
    'id-ID': 'Hapus Grup'
  },
  '导出分组': {
    'en-US': 'Export Group',
    'th-TH': 'ส่งออกกลุ่ม',
    'vi-VN': 'Xuất nhóm',
    'ms-MY': 'Eksport Kumpulan',
    'id-ID': 'Ekspor Grup'
  },
  '贴纸信息': {
    'en-US': 'Sticker Info',
    'th-TH': 'ข้อมูลสติ๊กเกอร์',
    'vi-VN': 'Thông tin sticker',
    'ms-MY': 'Maklumat Pelekat',
    'id-ID': 'Info Stiker'
  },
  '添加贴纸': {
    'en-US': 'Add Sticker',
    'th-TH': 'เพิ่มสติ๊กเกอร์',
    'vi-VN': 'Thêm sticker',
    'ms-MY': 'Tambah Pelekat',
    'id-ID': 'Tambah Stiker'
  },
  '修改贴纸': {
    'en-US': 'Edit Sticker',
    'th-TH': 'แก้ไขสติ๊กเกอร์',
    'vi-VN': 'Sửa sticker',
    'ms-MY': 'Edit Pelekat',
    'id-ID': 'Edit Stiker'
  },
  '删除贴纸': {
    'en-US': 'Delete Sticker',
    'th-TH': 'ลบสติ๊กเกอร์',
    'vi-VN': 'Xóa sticker',
    'ms-MY': 'Padam Pelekat',
    'id-ID': 'Hapus Stiker'
  },
  '导出贴纸': {
    'en-US': 'Export Sticker',
    'th-TH': 'ส่งออกสติ๊กเกอร์',
    'vi-VN': 'Xuất sticker',
    'ms-MY': 'Eksport Pelekat',
    'id-ID': 'Ekspor Stiker'
  },

  // ==================== 新产品管理 ====================
  '新产品管理': {
    'en-US': 'New Product',
    'th-TH': 'จัดการผลิตภัณฑ์ใหม่',
    'vi-VN': 'Quản lý sản phẩm mới',
    'ms-MY': 'Pengurusan Produk Baharu',
    'id-ID': 'Manajemen Produk Baru'
  },

  // ==================== 员工管理 ====================
  '员工管理': {
    'en-US': 'Employee',
    'th-TH': 'จัดการพนักงาน',
    'vi-VN': 'Quản lý nhân viên',
    'ms-MY': 'Pengurusan Pekerja',
    'id-ID': 'Manajemen Karyawan'
  },
  '新增员工': {
    'en-US': 'Add Employee',
    'th-TH': 'เพิ่มพนักงาน',
    'vi-VN': 'Thêm nhân viên',
    'ms-MY': 'Tambah Pekerja',
    'id-ID': 'Tambah Karyawan'
  },
  '修改员工': {
    'en-US': 'Edit Employee',
    'th-TH': 'แก้ไขพนักงาน',
    'vi-VN': 'Sửa nhân viên',
    'ms-MY': 'Edit Pekerja',
    'id-ID': 'Edit Karyawan'
  },
  '删除员工': {
    'en-US': 'Delete Employee',
    'th-TH': 'ลบพนักงาน',
    'vi-VN': 'Xóa nhân viên',
    'ms-MY': 'Padam Pekerja',
    'id-ID': 'Hapus Karyawan'
  },
  '启用员工': {
    'en-US': 'Enable Employee',
    'th-TH': 'เปิดใช้งานพนักงาน',
    'vi-VN': 'Kích hoạt nhân viên',
    'ms-MY': 'Aktifkan Pekerja',
    'id-ID': 'Aktifkan Karyawan'
  },
  '停用员工': {
    'en-US': 'Disable Employee',
    'th-TH': 'ปิดใช้งานพนักงาน',
    'vi-VN': 'Vô hiệu hóa nhân viên',
    'ms-MY': 'Nyahaktifkan Pekerja',
    'id-ID': 'Nonaktifkan Karyawan'
  },
  '重置密码': {
    'en-US': 'Reset Password',
    'th-TH': 'รีเซ็ตรหัสผ่าน',
    'vi-VN': 'Đặt lại mật khẩu',
    'ms-MY': 'Tetap Semula Kata Laluan',
    'id-ID': 'Setel Ulang Kata Sandi'
  }
}



// WEBPACK FOOTER //
// ./src/lang/menuTranslations.js